import { useSelector, useDispatch } from "react-redux";
import { FixMeLater } from "types";
import { useContext, useState } from "react";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import { useHistory } from "react-router-dom";
import { sharedLib } from "@shared/services/shared.service";
import { useAuthContext } from "common/Auth/AuthContext";
import {
  resetAnalyticsIdentity,
  clearVerificationEvents,
} from "analytics/client";

const useLogout = (): [() => Promise<FixMeLater>, { isLoading?: boolean }] => {
  const dispatch = useDispatch();
  const { analytics } = useContext(AnalyticsContext);
  const { setIsLoggingOut } = useAuthContext();
  const history = useHistory();
  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const refreshToken = useSelector(
    sharedLib.selectors.authentication.selectRefreshToken
  );
  const [isLoading, setIsLoading] = useState(false);
  const [logout, logoutStatus] =
    sharedLib.sharedApi.authentication.useLogoutMutation({
      fixedCacheKey: "logout",
    });

  const handleLogout = async (): Promise<FixMeLater> => {
    setIsLoading(true);
    setIsLoggingOut(true);
    if (user?.should_track) analytics?.userLoggedOut({});
    resetAnalyticsIdentity();
    clearVerificationEvents();
    dispatch(sharedLib.baseApi.util.resetApiState());
    history.push("/");
    return logout({ refresh_token: refreshToken })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
        setIsLoggingOut(false);
      });
  };

  return [handleLogout, { isLoading: logoutStatus.isLoading || isLoading }];
};

export default useLogout;
